import { Languages } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { SUPPORTED_LOCALES } from "@/lib/i18n";

// Optional `locales` restricts which options are shown (e.g. the tenant portal
// passes only the fully translated locales). Omitting it shows all supported
// locales, so existing callers (the manager header) are unchanged.
export function LocaleToggle({ locales }: { locales?: readonly string[] }) {
  const { i18n } = useTranslation();
  const options = locales
    ? SUPPORTED_LOCALES.filter((l) => locales.includes(l.code))
    : SUPPORTED_LOCALES;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="h-9 gap-1.5 text-muted-foreground hover:text-foreground"
        >
          <Languages className="h-4 w-4" />
          <span className="text-xs font-mono uppercase">
            {i18n.language.split("-")[0]}
          </span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {options.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => i18n.changeLanguage(l.code)}
          >
            {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
